import { fetchWrapper, handleResponse, buildOpts, hcUrl } from '../helpers';

const getBottomSheet = async ({ params }) => {
  const { menuSlug } = params;

  const response = await fetchWrapper(
    hcUrl(`/user_incentives/bottom_sheet/${menuSlug}`),
    buildOpts()
  );
  return handleResponse(response);
};

export { getBottomSheet };
